import React from 'react';
import './landing.css';
import { Typography, Grid, useMediaQuery } from "@material-ui/core";
import lines from "../images/wave.png";
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Parallax } from 'react-scroll-parallax';

const Onboard = require('./images/Onboarding.png');
const Adoption = require('./images/Adoption.png');
const Training = require('./images/Training.png');
const Support = require('./images/Support.png');

function CarouselSection(props) {
    const ParallaxSize = useMediaQuery('(max-width: 960px)');
    const [firstActive, setFirstActive] = React.useState(true);
    const [secondActive, setSecondActive] = React.useState(false);
    const [thirdActive, setThirdActive] = React.useState(false);
    const [fourthActive, setFourthActive] = React.useState(false);

    return (
        <div className="carousel-section">
            <Grid container justify="center">
                <Grid item xs={12} sm={12} md={8}>
                    <div className={`carousel-section__image ${firstActive ? 'carousel-section__image--active' : ''}`}>
                        <img src={Onboard} alt="Onboarding" />
                    </div>
                    <div className={`carousel-section__image ${secondActive ? 'carousel-section__image--active' : ''}`}>
                        <img src={Adoption} alt="Adoption" />
                    </div>
                    <div className={`carousel-section__image ${thirdActive ? 'carousel-section__image--active' : ''}`}>
                        <img src={Training} alt="Training" />
                    </div>
                    <div className={`carousel-section__image ${fourthActive ? 'carousel-section__image--active' : ''}`}>
                        <img src={Support} alt="Suport" />
                    </div>
                </Grid>
                <Grid item xs={9} sm={9} md={4} className="carousel-section__container">
                    <div className={`carousel-section__item ${firstActive ? 'carousel-section__item--active' : ''}`}
                        onClick={() => {
                            setFirstActive(true);
                            setSecondActive(false);
                            setThirdActive(false);
                            setFourthActive(false);
                        }}>
                        <div className="carousel-section__expand-icon">
                            {firstActive ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </div>
                        <Typography variant='h6' className="carousel-section__item__title">{props.titleA}</Typography>
                        <Typography variant='body1' className="carousel-section__item__body">{props.descriptionA}</Typography>
                    </div>

                    <div className={`carousel-section__item ${secondActive ? 'carousel-section__item--active' : ''}`}
                        onClick={() => {
                            setFirstActive(false);
                            setSecondActive(true);
                            setThirdActive(false);
                            setFourthActive(false);
                        }}>
                        <div className="carousel-section__expand-icon">
                            {secondActive ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </div>
                        <Typography variant='h6' className="carousel-section__item__title">{props.titleB}</Typography>
                        <Typography variant='body1' className="carousel-section__item__body">{props.descriptionB}</Typography>
                    </div>

                    <div className={`carousel-section__item ${thirdActive ? 'carousel-section__item--active' : ''}`}
                        onClick={() => {
                            setFirstActive(false);
                            setSecondActive(false);
                            setThirdActive(true);
                            setFourthActive(false);
                        }}>
                        <div className="carousel-section__expand-icon">
                            {thirdActive ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </div>
                        <Typography variant='h6' className="carousel-section__item__title">{props.titleC}</Typography>
                        <Typography variant='body1' className="carousel-section__item__body">{props.descriptionC}</Typography>
                    </div>
                    <div className={`carousel-section__item ${fourthActive ? 'carousel-section__item--active' : ''}`}
                        onClick={() => {
                            setFirstActive(false);
                            setSecondActive(false);
                            setThirdActive(false);
                            setFourthActive(true);
                        }}>
                        <div className="carousel-section__expand-icon">
                            {fourthActive ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </div>
                        <Typography variant='h6' className="carousel-section__item__title">{props.titleD}</Typography>
                        <Typography variant='body1' className="carousel-section__item__body">{props.descriptionD}</Typography>
                    </div>
                </Grid>
            </Grid>
            {!ParallaxSize ? <Parallax y={[-50, 15]} className="carousel-section__line-container">
                <img src={lines} alt="" className="carousel-section__lines" />
            </Parallax> : <Parallax y={[-250, 75]} className="carousel-section__line-container">
                    <img src={lines} alt="" className="carousel-section__lines" />
                </Parallax>}

        </div>
    );
}

export default CarouselSection